export default __webpack_public_path__ + "static/media/file-expense.ab50f8df.svg";